import { Injectable } from "@angular/core"
import { Router, Resolve, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router'
import { Store, Action } from "@ngrx/store"
import { Actions } from "@ngrx/effects";
import { AppState } from "@store/app-state"
import { Observable } from "rxjs/Observable"
import { Observer } from "rxjs/Observer"
import { WorkshopEffects } from "@reducers/effects/workshop";
import {
  FETCH_WORKSHOPS,
  POPULATE_WORKSHOPS
} from "@reducers/workshops"
import { ConstantsStore } from "@store/constants";

@Injectable()
export class WorkshopsViewResolver implements Resolve<boolean> {

  constructor(
    private actions: Actions,
    private store: Store<AppState>,
  ) {}

  resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
    let termId: number = 0
    this.store.select("constantsReducer").take(1).subscribe((s: ConstantsStore) => {
      termId = s.constants.terms.filter(t => !t.isHoliday)[0].id
    })

    this.store.dispatch({ type: FETCH_WORKSHOPS, payload: termId })

    return this.actions
      .ofType(POPULATE_WORKSHOPS)
      .take(1)
      .mapTo(true)
  }

}



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/app/resolvers/workshops-view.ts